export const POSTS = 'posts'
